<h2 matDialogTitle class="mat-h2">Edit Ad</h2>

<mat-dialog-content>
  <mat-divider></mat-divider>
  <p class="mat-body-2">Changes to ads occur immediately.</p>

  <div *ngIf="data.merchantAds.length > 1" class="bulk-edit-inputs">
    <mat-form-field class="bulk-select">
      <mat-label>Bulk Edit</mat-label>
      <mat-select [formControl]="bulkEditControls.bulkEditSelect">
        <mat-option value="none">None</mat-option>
        <mat-option value="adTitle">Ad Name</mat-option>
        <mat-option value="destinationUrl">Destination URL</mat-option>
        <mat-option *ngIf="startDateInFutureExists" value="startDateTime">Start Date Time</mat-option>
        <mat-option value="endDateTime">End Date Time</mat-option>
        <mat-option value="affiliateExclusive">Affiliate Designation</mat-option>
      </mat-select>
      <mat-hint>Choose a column to bulk edit</mat-hint>
    </mat-form-field>

    <ng-container [ngSwitch]="bulkEditControls.bulkEditSelect.value">
      <mat-form-field *ngSwitchCase="'adTitle'" subscriptSizing="fixed">
        <mat-label>Ad Name</mat-label>
        <input matInput placeholder="For internal reporting" [formControl]="bulkEditControls.adTitle">
        <mat-error>{{bulkEditControls.adTitle.errors | validationMessage}}</mat-error>
      </mat-form-field>

      <mat-form-field *ngSwitchCase="'destinationUrl'" subscriptSizing="fixed">
        <mat-label>Destination URL</mat-label>
        <input matInput placeholder="Webpage the ad goes to" [formControl]="bulkEditControls.destinationUrl">
        <mat-error>{{bulkEditControls.destinationUrl.errors | validationMessage}}</mat-error>
      </mat-form-field>

      <ng-container *ngSwitchCase="'startDateTime'">
        <mat-form-field floatLabel='always' subscriptSizing="fixed">
          <mat-label>Start Date</mat-label>
          <input matInput [matDatepicker]="startDatePickerBulk" [formControl]="bulkEditControls.startDateStartOfDay">
          <mat-datepicker-toggle matSuffix [for]="startDatePickerBulk"></mat-datepicker-toggle>
          <mat-datepicker #startDatePickerBulk></mat-datepicker>
          <mat-error>{{bulkEditControls.startDateStartOfDay.errors | validationMessage}}</mat-error>
        </mat-form-field>

        <mat-form-field subscriptSizing="fixed">
          <mat-label>Start Time</mat-label>
          <mat-select [formControl]="bulkEditControls.startDateHour" [disabled]="bulkEditControls.startDateStartOfDay.value == null">
            <mat-option *ngFor="let option of hourTimeOptions" [value]="option.value">{{option.label}}</mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>

      <ng-container *ngSwitchCase="'endDateTime'">
        <mat-form-field floatLabel='always' subscriptSizing="fixed">
          <mat-label>End Date</mat-label>
          <input matInput [matDatepicker]="endDatePickerBulk" placeholder="No end date" [formControl]="bulkEditControls.endDateStartOfDay">
          <mat-datepicker-toggle matSuffix [for]="endDatePickerBulk"></mat-datepicker-toggle>
          <mat-datepicker #endDatePickerBulk></mat-datepicker>
          <mat-error>{{bulkEditControls.endDateStartOfDay.errors | validationMessage}}</mat-error>
        </mat-form-field>

        <mat-form-field subscriptSizing="fixed">
          <mat-label>End Time</mat-label>
          <mat-select [formControl]="bulkEditControls.endDateHour" [disabled]="bulkEditControls.endDateStartOfDay.value == null">
            <mat-option *ngFor="let option of hourTimeOptions" [value]="option.value">{{option.label}}</mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>

      <mat-form-field *ngSwitchCase="'affiliateExclusive'" [floatLabel]="'always'" class="select-field exclusive-form-field" subscriptSizing="fixed">
        <mat-label>Affiliate Designation</mat-label>
        <input type="text"
               placeholder="Affiliate Name, URL, Classic ID, Tag Group"
               aria-label="Affiliate Designation"
               matInput
               [formControl]="bulkEditControls.affiliateExclusive"
               [matAutocomplete]="bulkExclusiveAuto"
               #bulkExclusiveInput>
        <mat-autocomplete #bulkExclusiveAuto="matAutocomplete" [class]="'exclusive-autocomplete'" [displayWith]="exclusiveFilterDisplayWith"
                          (optionSelected)="bulkExclusiveFilterAutoCompleteOnSelected($event, bulkExclusiveInput)" (opened)="autoSelectOnOpened(bulkEditControls.affiliateExclusive)" (closed)="bulkExclusiveFilterAutoCompleteOnClosed(bulkEditControls.affiliateExclusive)">
          <mat-option [value]="allAffiliatesOption" class="autocomplete-option">{{allAffiliatesOption.affiliate_name}}</mat-option>
          <mat-option *ngFor="let affiliateOption of affiliateFilteredOptionsLimited$ | async" class="autocomplete-option" [value]="affiliateOption">
            <div class="mat-subtitle-2">{{affiliateOption.affiliate_name}}</div>
            <div class="mat-body-2">{{affiliateOption.affiliate_website_url_protocol_stripped}}</div>
            <span class="circle circle-green">&nbsp;</span>
            <span><mat-icon [svgIcon]="affiliateOption.affiliate_network"></mat-icon></span>
            <span class="classic-id mat-caption">{{affiliateOption.classic_affiliate_id}}</span>
          </mat-option>
          <mat-divider></mat-divider>
          <mat-optgroup [label]="'Tag Groups'">
            <mat-option *ngFor="let tagOption of userTagFilteredOptionsLimited$ | async" class="autocomplete-tag-option" [value]="tagOption">
              <span><mat-icon aria-hidden="false" aria-label="Tag Group icon" color="accent">groups</mat-icon></span><span class="mat-body-2">{{tagOption.tag_name | titlecase}}</span>
            </mat-option>
          </mat-optgroup>
          <mat-option *ngIf="(affiliateFilteredOptions$ | async)?.length > exclusiveAffiliateLimit || (userTagFilteredOptions$ | async)?.length > exclusiveTagLimit" [disabled]="true" class="autocomplete-option">
            <p class="mat-subtitle-2">Results limited. Filter to see more results.</p>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </ng-container>

    <button mat-raised-button type="button" color="accent"
      [disabled]="bulkEditControls.bulkEditSelect.value === 'none' || !bulkFormValid()" (click)="onBulkApplyClick()">Apply</button>
  </div>

  <ng-container [formGroup]="topFormGroup">
    <table mat-table [dataSource]="merchantAds$ | async" formArrayName="rows">
      <ng-container matColumnDef="adId">
        <td mat-cell *matCellDef="let row let i=index" [formGroupName]="i">
          <mat-form-field subscriptSizing="fixed">
            <mat-label>Ad Id</mat-label>
            <input matInput formControlName="adId">
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="ad">
        <td mat-cell *matCellDef="let row; let i=index" [formGroupName]="i">
          @if (row.ad_type === 'banner') {
            <img [ngSrc]="row.image_url" (click)="onImgClick(i)" [id]="'fileImage[' + i + ']'" width="{{row.image_width}}" height="{{row.image_height}}">
            <input type="file" [id]="'fileInput[' + i + ']'" accept=".gif,.jpeg,.jpg,.png" style="display:none" (change)="onFileInputChange($event, i)">
            <div class="wash-out">Banner {{row.image_width}}x{{row.image_height}}</div>
          }
          @if (row.ad_type === 'text') {
            <mat-form-field class="text-ad" subscriptSizing="fixed">
              <mat-label>Text Ad</mat-label>
              <textarea matInput placeholder="This is what customers see" cdkTextareaAutosize formControlName="linkText" #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="7"></textarea>
              <mat-error>{{topControls.rows.at(i).get('linkText').errors | validationMessage}}</mat-error>
            </mat-form-field>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="adDetails">
        <td mat-cell *matCellDef="let row; let i=index" [formGroupName]="i">
          <div class="td-liner-inputs">
            <mat-form-field subscriptSizing="fixed">
              <mat-label>Ad Name</mat-label>
              <input matInput placeholder="For internal reporting" formControlName="adTitle">
              <mat-error>{{topControls.rows.at(i).get('adTitle').errors | validationMessage}}</mat-error>
            </mat-form-field>

            <mat-form-field subscriptSizing="fixed">
              <mat-label>Destination URL</mat-label>
              <input matInput placeholder="Webpage the ad goes to" formControlName="destinationUrl">
              <mat-error>{{topControls.rows.at(i).get('destinationUrl').errors | validationMessage}}</mat-error>
            </mat-form-field>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="startDate">
        <td mat-cell *matCellDef="let row; let i=index" [formGroupName]="i">
          <div class="td-liner-inputs">
            <mat-form-field floatLabel='always' subscriptSizing="fixed">
              <mat-label>Start Date</mat-label>
              <input matInput [matDatepicker]="startDatePicker" formControlName="startDateStartOfDay">
              <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #startDatePicker></mat-datepicker>
              <mat-error>{{topControls.rows.at(i).get('startDateStartOfDay').errors | validationMessage}}</mat-error>
            </mat-form-field>

            <mat-form-field subscriptSizing="fixed">
              <mat-label>Start Time</mat-label>
              <mat-select formControlName="startDateHour" [disabled]="topControls.rows.at(i).get('startDateStartOfDay').value == null">
                <mat-option *ngFor="let option of hourTimeOptions" [value]="option.value">{{option.label}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="endDate">
        <td mat-cell *matCellDef="let row; let i=index" [formGroupName]="i">
          <div class="td-liner-inputs">
            <mat-form-field floatLabel='always' subscriptSizing="fixed">
              <mat-label>End Date</mat-label>
              <input matInput [matDatepicker]="endDatePicker" placeholder="No end date" formControlName="endDateStartOfDay">
              <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #endDatePicker></mat-datepicker>
              <mat-error>{{topControls.rows.at(i).get('endDateStartOfDay').errors | validationMessage}}</mat-error>
            </mat-form-field>

            <mat-form-field subscriptSizing="fixed">
              <mat-label>End Time</mat-label>
              <mat-select formControlName="endDateHour" [disabled]="topControls.rows.at(i).get('endDateStartOfDay').value == null">
                <mat-option *ngFor="let option of hourTimeOptions" [value]="option.value">{{option.label}}</mat-option>
              </mat-select>
              <mat-error>{{topControls.rows.at(i).get('endDateHour').errors | validationMessage}}</mat-error>
            </mat-form-field>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="affiliateDesignation">
        <td mat-cell *matCellDef="let row; let i=index" [formGroupName]="i">
          <div>
            <mat-form-field [floatLabel]="'always'" subscriptSizing="fixed">
              <mat-label>Affiliate Designation</mat-label>
              <input type="text"
                     placeholder="Affiliate Name, URL, Classic ID, Tag Group"
                     aria-label="Affiliate Designation"
                     matInput
                     formControlName="affiliateExclusive"
                     [matAutocomplete]="singleExclusiveAuto"
                     #singleExclusiveInput>
              <mat-autocomplete #singleExclusiveAuto="matAutocomplete" [class]="'exclusive-autocomplete'" [displayWith]="exclusiveFilterDisplayWith"
                                (optionSelected)="exclusiveFilterAutoCompleteOnSelected($event, singleExclusiveInput, i)"
                                (opened)="autoSelectOnOpened(topControls.rows.at(i).get('affiliateExclusive'))"
                                (closed)="exclusiveFilterAutoCompleteOnClosed(topControls.rows.at(i).get('affiliateExclusive'), i)">
                <mat-option [value]="allAffiliatesOption" class="autocomplete-option">{{allAffiliatesOption.affiliate_name}}</mat-option>
                <mat-option *ngFor="let affiliateOption of affiliateFilteredOptionsLimited$ | async" class="autocomplete-option" [value]="affiliateOption">
                  <div class="mat-subtitle-2">{{affiliateOption.affiliate_name}}</div>
                  <div class="mat-body-2">{{affiliateOption.affiliate_website_url_protocol_stripped}}</div>
                  <span class="circle circle-green">&nbsp;</span>
                  <span><mat-icon [svgIcon]="affiliateOption.affiliate_network"></mat-icon></span>
                  <span class="classic-id mat-caption">{{affiliateOption.classic_affiliate_id}}</span>
                </mat-option>
                <mat-divider></mat-divider>
                <mat-optgroup [label]="'Tag Groups'">
                  <mat-option *ngFor="let tagOption of userTagFilteredOptionsLimited$ | async" class="autocomplete-tag-option" [value]="tagOption">
                    <span><mat-icon aria-hidden="false" aria-label="Tag Group icon" color="accent">groups</mat-icon></span><span class="mat-body-2">{{tagOption.tag_name | titlecase}}</span>
                  </mat-option>
                </mat-optgroup>
                <mat-option *ngIf="(affiliateFilteredOptions$ | async)?.length > exclusiveAffiliateLimit || (userTagFilteredOptions$ | async)?.length > exclusiveTagLimit" [disabled]="true" class="autocomplete-option">
                  <p class="mat-subtitle-2">Filter to see more results.</p>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </td>
      </ng-container>

      <tr mat-row *matRowDef="let row; columns: visibleColumns;"></tr>

      <tr class="mat-mdc-row" *matNoDataRow>
        <td class="mat-mdc-cell" [attr.colspan]="6">loading...</td>
      </tr>
    </table>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" class="white" [mat-dialog-close]="saveErrorOccurred">Cancel</button> &nbsp;
  <button mat-raised-button type="button" color="primary"
    [disabled]="topFormGroup.invalid || savingInProgress" (click)="onSaveClick()">{{savingInProgress ? 'Saving...' : 'Save'}}</button>
</mat-dialog-actions>
